import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const productToProcessSchema_ = z.object({
  _id: zExt.objectId(),
  returnValue: z.number().nullish(),
  restock: z.boolean(),
  reject: z.boolean(),
  merchantGrade: z.string().nullish(),
  merchantOutcome: z.string().nullish(),
  merchantNotes: z.string().nullish(),
  shipHeroBin: z.string().nullish(),
});
export const productToProcessSchema: z.ZodType<ProductToProcess> =
  productToProcessSchema_;
export type ProductToProcess = z.infer<typeof productToProcessSchema_>;
